"use client";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useSiniestrosStore from '../../../store/siniestrosStore';
import { getToken, getValidateType, removeValidateType, removeToken } from '../../../utils/claimManager';
import { Loader, SpanError } from '../../../components';
import { Button, Input } from 'atm-global-stylish/dist';
import { useNavigate } from 'react-router-dom';
import SinisterForm from '../../../components/SinisterForm/SinisterForm';
import { isEmpty, isset, isValidDate, scrollToTop, showModal } from '../../../utils/functions';
import { INPUT_CLASSNAME } from '../../../config/constants';

const Step2 = ({ avanzar, retroceder, config, loader, formData, setFormData, fetchSinisterData, instance, updateClaim, fetchSinisterNumber, goToStep, getInstance, clearInstance }) => {
    const { loading } = useSiniestrosStore();
    const [sinisterData, setSinisterData] = useState({
        sinister_time: '',
        sinister_address: '',
        sinister_location: '',
        sinister_province: '',
        sinister_country: '',
        sinister_detail: '',
    });
    const [errors, setErrors] = useState({});
    const [validateError, setValidateError] = useState(false);
    const [arrayErrors, setArrayErrors] = useState([]);
    const navigation = useNavigate()

    useEffect(() => {
        (async () => {
            const token = getToken();
            if (!token) {
                clearInstance()
                navigation('/');
            } else {
                const responseInstance = await getInstance(token);

                if (!isset(responseInstance.things)) {
                    clearInstance()
                    navigation('/');
                }
            }
        })();
    }, []);

    const handleChange = (field) => (e) => {
        setSinisterData(prev => ({ ...prev, [field]: e.target.value }));
    };

    useEffect(() => {
        if (instance) {
            setFormData((prev) => ({
                ...prev,
                sinister_date: instance.sinister_date
            }));

            setSinisterData({
                sinister_time: instance.sinister_time || '',
                sinister_address: instance.sinister_address || '',
                sinister_location: instance.sinister_location || '',
                sinister_province: instance.sinister_province || '',
                sinister_country: instance.sinister_country || '',
                sinister_detail: instance.sinister_detail || '',
            });
        }
    }, [instance]);

    const validateFields = () => {
        const newErrors = {};

        if (!sinisterData.sinister_time?.trim()) newErrors.sinister_time = true;
        if (!sinisterData.sinister_address.trim()) newErrors.sinister_address = true;
        if (!sinisterData.sinister_country) newErrors.sinister_country = true;
        if (!sinisterData.sinister_detail.trim()) newErrors.sinister_detail = true;
        if (!sinisterData.sinister_location) newErrors.sinister_location = true;
        if (!sinisterData.sinister_province) newErrors.sinister_province = true;

        if (sinisterData.sinister_address.trim().length < 3) newErrors.sinister_address = true;
        if (sinisterData.sinister_detail.trim().length < 3) newErrors.sinister_detail = true;
        if (sinisterData.sinister_location.length < 3) newErrors.sinister_location = true;
        if (sinisterData.sinister_province.length < 3) newErrors.sinister_province = true;
        if (sinisterData.sinister_country.length < 3) newErrors.sinister_country = true;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleValidateSinister = async () => {
        scrollToTop();

        let arrayErrorsAux = [];

        if (!formData.sinister_date) {
            setErrors({ sinister_date: true });
            arrayErrorsAux['sinister_date'] = 'Debe ingresar una fecha válida';
            setArrayErrors(arrayErrorsAux);
            return;
        };

        const today = new Date();

        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // meses empiezan en 0
        const day = String(today.getDate()).padStart(2, "0");

        const formattedDate = `${year}-${month}-${day}`;

        if (formData.sinister_date > formattedDate) {
            setErrors({ sinister_date: true });
            arrayErrorsAux['sinister_date'] = 'Debe ingresar una fecha igual o anterior al día de hoy';
            setArrayErrors(arrayErrorsAux);
            return;
        }

        if (!isValidDate(formData.sinister_date)) {
            setErrors({ sinister_date: true });
            arrayErrorsAux['sinister_date'] = 'Debe ingresar una fecha válida';
            setArrayErrors(arrayErrorsAux);
            return;
        }

        setErrors({});

        const cleanParams = Object.fromEntries(
            Object.entries(formData).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        );

        const token = getToken();
        try {
            const type = getValidateType();
            if (type === 1) {
                const validated = await fetchSinisterNumber(cleanParams);
                if (validated) {
                    setValidateError(false);
                } else {
                    setValidateError(true);
                }
            }
            if (type === 2) {
                const validated = await fetchSinisterData(cleanParams)
                if (validated) {
                    setValidateError(false);
                } else {
                    setValidateError(true);
                }
            }
            getInstance(token)
            return;

        } catch (err) {
            showModal('¡UPS! Hubo un error al validar el siniestro', err.message || 'Error desconocido al momento de la validación del siniestro. Intente nuevamente más tarde.', 'error');
        }
    };

    const handleContinue = async () => {
        if (!validateFields()) {
            await showModal('Campos incompletos', 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.', 'warning');
            return false;
        };
        const dataSinister = {
            sinister_time: sinisterData.sinister_time,
            sinister_address: sinisterData.sinister_address,
            sinister_location: sinisterData.sinister_location,
            sinister_province: sinisterData.sinister_province,
            sinister_country: sinisterData.sinister_country,
            sinister_detail: sinisterData.sinister_detail,
        }

        const cleanParams = Object.fromEntries(
            Object.entries(dataSinister).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        );
        const token = getToken();
        try {
            const updated = await updateClaim(token, cleanParams);

            if (updated) {
                const response = await getInstance(token);

                if (!isEmpty(response.uuid)) {
                    let cont = 0;
                    Object.entries(cleanParams).forEach((obj) => {
                        if (isEmpty(response[obj[0]])) {
                            cont++;
                        }
                    });

                    if (cont === 0)
                        avanzar();
                    else
                        await showModal('Campos incompletos', 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.');
                } else {
                    showModal('¡UPS! Hubo un error al continuar con la operación', 'Error desconocido al momento de actualizar los datos del siniestro. Intente nuevamente más tarde.');
                }
            }
        } catch (err) {
            showModal('¡UPS! Hubo un error al continuar con la operación', err.message || 'Error desconocido al momento de actualizar los datos del siniestro. Intente nuevamente más tarde.');
        }
    };

    const handleBack = () => {
        const validateType = getValidateType();
        if (validateType === 1) {
            setFormData({
                branch: "",
                dni: "",
                policy: "",
                plate: "",
                sinister_date: "",
            })
            removeToken();
            removeValidateType();
            const token = getToken();
            if (!token) {
                goToStep(0);
            }
        } else {
            retroceder();
        }
    }

    if (loading || loader) return <Loader />;

    return (
        <div className='step1 md:w-8/12 m-auto my-8 px-5 md:px-0'>
            <div className='flex w-full m-auto flex-col gap-6'>
                {!instance?.atm_sinister_number && (
                    <>
                        <div className="flex flex-col">
                            <Input
                                type='date'
                                value={formData.sinister_date}
                                handleChange={(e) => {
                                    setArrayErrors((prev) => ({ ...prev, sinister_date: null }));
                                    setFormData(prev => ({ ...prev, sinister_date: e.target.value }));
                                }}
                                label='Fecha del siniestro *'
                                className={INPUT_CLASSNAME}
                            />
                            {
                                arrayErrors?.sinister_date && (<SpanError text={arrayErrors.sinister_date} />)
                            }
                            {validateError && (
                                <p className="text-pink text-sm text-center mb-4 mt-4">No hemos encontrado denuncia de siniestro con la información proporcionada, por favor, volvé a intentarlo en unos dias.</p>
                            )}
                        </div>

                    </>
                )}
                {instance?.atm_sinister_number &&
                    <SinisterForm errors={errors} handleChange={handleChange} sinisterData={sinisterData} />
                }
                {Object.keys(errors).length > 0 && (
                    <p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
                )}
                <div className='flex flex-col-reverse md:flex-row w-full justify-between gap-5 mt-8 md:mt-10 mb-8'>
                    <Button handleClick={handleBack} title='Volver al paso anterior' className='w-full p-2 md:p-3 text-center' type='secondary' />
                    {instance?.atm_sinister_number ?
                        <Button handleClick={handleContinue} title='Siguiente' className='w-full p-3 text-center border-red border' type='primary' />
                        :
                        <Button handleClick={handleValidateSinister} title='Validar' className='w-full p-2 md:p-3 text-center border-red border' type='primary' />
                    }

                </div>
            </div>
        </div>
    );
};

Step2.propTypes = {
    avanzar: PropTypes.func,
    retroceder: PropTypes.func,
    formData: PropTypes.object,
    config: PropTypes.object,
    loader: PropTypes.bool,
    setFormData: PropTypes.func
};

export default Step2;